module.exports = __webpack_public_path__ + "img/pleisure_bodyimage01-3.3fd7aa54.jpg";